export function getView(current_location) {
  return current_location ? 'Exists' : 'NoLocation'
}
